document.addEventListener('DOMContentLoaded', () => {
  /*
  ==========================================
  INSIDER
  ==========================================
  */
  function insiderSendQuizForm({ email, phone, name }, ids, attribute = null) {
    try {
      if (!Array.isArray(ids)) throw new Error('The argument "ids" must be an array.');

      window.insider_object = window.insider_object || {};
      window.insider_object.user = {
        gdpr_optin: true,
        name: name,
        email: email,
        email_optin: true,
        phone_number: phone,
        static_segment_id: ids,
        custom: attribute,
      };

      Insider.eventManager.dispatch('init-manager:re-initialize');
    } catch (err) {
      console.error(err);
    }
  }

  /*
  ==========================================
  DATA
  ==========================================
  */

  const quizQuestions = window.quizQuestions || [];

  const quizProfiles = window.quizProfiles || [];

  const leadBlock = window.quizLeadBlock || {};

  /*
  ==========================================
  ELEMENTS
  ==========================================
  */

  const stage = document.querySelector('.quiz-dynamic-stage');

  const progressFill = document.querySelector('.quiz-progress-fill');

  const progressText = document.querySelector('.quiz-progress-text');

  /*
  ==========================================
  STATE
  ==========================================
  */

  let currentStep = 0;

  let scores = {};

  let totalPossibleWeight = 0;

  /*
  ==========================================
  INIT SCORES
  ==========================================
  */

  quizProfiles.forEach((profile) => {
    scores[profile.profile_key] = 0;
  });

  quizQuestions.forEach((question) => {
    totalPossibleWeight += parseInt(question.weight);
  });

  /*
  ==========================================
  UPDATE PROGRESS
  ==========================================
  */

  function updateProgress() {
    const progress = ((currentStep + 1) / quizQuestions.length) * 100;

    progressFill.style.width = `${progress}%`;

    progressText.innerText = `${currentStep + 1} de ${quizQuestions.length}`;
  }

  /*
  ==========================================
  RENDER QUESTION
  ==========================================
  */

  function renderQuestion(index) {
    const question = quizQuestions[index];

    if (!question) {
      renderLeadStep();

      return;
    }

    updateProgress();

    stage.innerHTML = `

      <div class="quiz-step">

        <div class="quiz-step-content">

          <h3>
            ${question.title}
          </h3>

          <div class="quiz-options">

            ${question.options
              .map(
                (option) => `

              <button
                class="quiz-option"
                data-profile="${option.profile}"
                data-weight="${question.weight}"
              >

                ${option.label}

              </button>

            `,
              )
              .join('')}

          </div>

        </div>

      </div>

    `;

    bindOptions();
  }

  /*
  ==========================================
  OPTIONS
  ==========================================
  */

  function bindOptions() {
    const buttons = document.querySelectorAll('.quiz-option');

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const profile = button.dataset.profile;

        const weight = parseInt(button.dataset.weight);

        scores[profile] += weight;

        currentStep++;

        renderQuestion(currentStep);
      });
    });
  }

  /*
  ==========================================
  LEAD STEP
  ==========================================
  */

  function renderLeadStep() {
    progressFill.style.width = '100%';
    progressText.innerText = 'Finalizando';
    stage.innerHTML = `
      <div class="quiz-lead-step active">

        <div class="quiz-lead-card">

          <span class="quiz-lead-badge">
            ÚLTIMO PASSO
          </span>

          <h3>
            ${leadBlock.title || ''}
          </h3>

          <p>
            ${leadBlock.description || ''}
          </p>

          <form id="quizLeadForm">

            <input
              type="text"
              id="quiz-name"
              placeholder="Seu nome"
              required
            >

            ${
              leadBlock.show_phone
                ? `

              <input
                type="tel"
                id="quiz-phone"
                placeholder="Seu telefone"
                required
              >

            `
                : ''
            }

            ${
              leadBlock.show_age
                ? `

              <input
                type="number"
                id="quiz-age"
                placeholder="Sua idade"
                required
              >

            `
                : ''
            }

            <input
              type="email"
              id="quiz-email"
              placeholder="Seu melhor e-mail"
              required
            >

            <button type="submit" class="button button--xl w-full">
              ${leadBlock.button || 'Ver resultado'}
            </button>

          </form>

          ${
            leadBlock.disclaimer
              ? `

            <div class="quiz-disclaimer">
              ${leadBlock.disclaimer}
            </div>

          `
              : ''
          }

        </div>

      </div>

    `;

    // const quizButton = document.querySelector('#quiz-view-results');

    // quizButton.addEventListener('click', (e) => {
    //   const quizName = document.querySelector('#quiz-name');
    //   const quizPhone = document.querySelector('#quiz-phone');
    //   const quizAge = document.querySelector('#quiz-age');
    //   const quizEmail = document.querySelector('#quiz-email');
    //   const quizListId = 2711088;

    //   if (typeof insiderSendQuizForm === 'function') {
    //     insiderSendQuizForm({
    //       email: quizEmail.value,
    //       phone: quizPhone.value,
    //     }, [quizListId], {
    //       age: quizAge.value,
    //       name: quizName.value
    //     });
    //     console.log('Dados enviados')
    //   }
    // });

    bindLeadForm();
  }

  /*
  ==========================================
  WINNING PROFILE
  ==========================================
  */

  function getWinningProfile() {
    return Object.keys(scores).reduce((a, b) => (scores[a] > scores[b] ? a : b));
  }

  /*
  ==========================================
  COMPATIBILITY
  ==========================================
  */

  function getCompatibility(profileKey) {
    const profileScore = scores[profileKey];

    return Math.round((profileScore / totalPossibleWeight) * 100);
  }

  /*
  ==========================================
  RESULT
  ==========================================
  */

  function renderResult(profileKey) {
    const profile = quizProfiles.find(
      (item) => item.profile_key.toLowerCase().trim() === profileKey.toLowerCase().trim(),
    );
    console.log('PROFILE KEY:', profileKey);
    console.log('AVAILABLE:', quizProfiles);

    if (!profile) return;

    const compatibility = getCompatibility(profileKey);
    console.log('>>>> PROFILE: ', [profile]);
    stage.innerHTML = `

      <div class="quiz-result-wrapper active">

        <div class="quiz-result-card">

          <span class="quiz-result-badge">
            ${compatibility}% COMPATÍVEL
          </span>

          <h2>
            ${profile.title}
          </h2>

          <p>
            ${profile.description}
          </p>

          <div class="quiz-routine-time">

            ⏱ Rotina média:
            <strong>
              ${profile.routine_time}
            </strong>

          </div>

          <div class="quiz-benefits">

            ${profile.benefits
              .split('<br />')
              .map(
                (item) => `
                <span>${item}</span>
              `,
              )
              .join('')}

          </div>

          <div class="quiz-featured-product">

            <img
              src="${profile.featured_product.image}"
              alt="${profile.featured_product.title}"
            >

            <div class="quiz-featured-content">

              <span>
                PRODUTO PROTAGONISTA
              </span>

              <h3>
                ${profile.featured_product.title}
              </h3>
            </div>

          </div>

          <div class="quiz-products-grid">

            ${profile.products
              .map(
                (product) => `

              <div class="quiz-product-card">
                <img
                  src="${product.image}"
                  alt="${product.title}"
                >

                <div class="quiz-product-info h-stack gap-2 align-center">
                  <div style="flex:1;">
                    <h4>
                      ${product.title}
                    </h4>

                    <p>
                      ${product.description}
                    </p>
                  </div>

                  <form method="post" action="/cart/add" accept-charset="UTF-8" class="shopify-product-form" enctype="multipart/form-data" is="product-form">
                    <input type="hidden" name="id" value="${product.variant_id}"/>
                    <button type="submit" class="button button--xs" is="custom-button">
                      <div>Adicionar à sacola</div>
                      <span class="button__loader">
                        <span></span>
                        <span></span>
                        <span></span>
                      </span>
                    </button>
                  </form>
                </div>
              </div>
            `,
              )
              .join('')}
          </div>
        </div>
      </div>
    `;

    bindCartButtons();
  }

  /*
  ==========================================
  LEAD FORM
  ==========================================
  */

  function bindLeadForm() {
    const form = document.getElementById('quizLeadForm');

    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      const nameField = document.getElementById('quiz-name');

      const phoneField = document.getElementById('quiz-phone');

      const ageField = document.getElementById('quiz-age');

      const emailField = document.getElementById('quiz-email');

      const leadData = {
        name: nameField ? nameField.value : '',
        phone: phoneField ? phoneField.value : '',
        age: ageField ? ageField.value : '',
        email: emailField ? emailField.value : '',
        profile: getWinningProfile(),
      };

      /*
    ==========================================
    DEBUG
    ==========================================
    */

      console.log('LEAD DATA:', leadData);

      /*
    ==========================================
    INSIDER
    ==========================================
    */

      if (window.Insider && window.Insider.eventManager) {
        window.Insider.eventManager.dispatch('quiz_completed', leadData);
      }

      if (window.insider_object) {
        insiderSendQuizForm(
          {
            name: leadData.name,
            email: leadData.name,
            phone: leadData.phone,
          },
          ['475'],
          {
            age: leadData.age,
            profile: leadData.profile,
          },
        );
      }

      /*
    ==========================================
    RESULT
    ==========================================
    */

      renderResult(leadData.profile || 'FIRMEZA');
    });
  }

  /*
  ==========================================
  CART
  ==========================================
  */

  function bindCartButtons() {
    const buttons = document.querySelectorAll('.quiz-add-cart');

    buttons.forEach((button) => {
      button.addEventListener('click', async () => {
        const variantId = button.dataset.variantId;

        await fetch('/cart/add.js', {
          method: 'POST',

          headers: {
            'Content-Type': 'application/json',
          },

          body: JSON.stringify({
            items: [
              {
                id: variantId,
                quantity: 1,
              },
            ],
          }),
        });

        /*
        ==========================================
        IMPACT CART
        ==========================================
        */

        document.documentElement.dispatchEvent(
          new CustomEvent('cart:refresh', {
            bubbles: true,
          }),
        );

        document.documentElement.dispatchEvent(
          new CustomEvent('cart:open', {
            bubbles: true,
          }),
        );
      });
    });
  }

  /*
  ==========================================
  INIT
  ==========================================
  */

  renderQuestion(currentStep);
});
